export const messages = {
  title: {
    id: 'admin/promotions.form.change-benefit.modal.title',
  },
  subtitle: {
    id: 'admin/promotions.form.change-benefit.modal.subtitle',
  },
  accumulateWithManual: {
    section: {
      id: 'admin/promotions.form.accumulations.title',
    },
    config: {
      id: 'admin/promotions.form.change-benefit.modal.accumulate-with-manual-prices',
    },
  },
  accumulate: {
    section: {
      id: 'admin/promotions.form.accumulations.title',
    },
    config: {
      id: 'admin/promotions.form.change-benefit.modal.accumulate',
    },
  },
  restrictionsAttribute: {
    section: {
      id: 'admin/promotions.form.restrictions.title',
    },
    config: {
      id: 'admin/promotions.form.change-benefit.modal.max-per-attribute',
    },
  },
  restrictionsCart: {
    section: {
      id: 'admin/promotions.form.restrictions.title',
    },
    config: {
      id: 'admin/promotions.form.change-benefit.modal.max-per-cart',
    },
  },
  budget: {
    section: {
      id: 'admin/promotions.form.budget.title',
    },
    config: {
      id: 'admin/promotions.form.change-benefit.modal.budget',
    },
  },
  continue: {
    id: 'admin/promotions.utils.modal.confirmation.subtitle',
  },
  footer: {
    cancel: {
      id: 'admin/promotions.utils.cancel',
    },
    confirm: {
      id: 'admin/promotions.utils.confirm',
    },
  },
}
